import React, { useState, useEffect } from "react";
import { Row, Col, Card, Modal } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import Axios from "axios";
import {
  Alert,
  BackButton,
  ActionButton,
  UpdateButton,
  DeleteButton,
  DataStatus,
  Input,
  SelectSearch,
  Table,
  THead,
  TBody,
  Tr,
  ThFixed,
  TdFixed,
  Th,
  Td,
  DatePicker,
  InputCurrency,
} from "../../../../components";
import { DateConvert, RupiahConvert } from "../../../../utilities";
import { SeleksiVendorApi, VendorApi } from "../../../../api";
import { IoAddOutline } from "react-icons/io5";

const UbahSeleksiVendor = ({ setNavbarTitle }) => {
  const history = useHistory();
  const { id } = useParams();
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [isFetchingFailed, setIsFetchingFailed] = useState(false);
  const [dataSeleksiVendor, setDataSeleksiVendor] = useState([]);
  const [dataVendor, setDataVendor] = useState([]);
  const [dataListItemSeleksiVendor, setDataListItemSeleksiVendor] = useState(
    []
  );
  const [processedData, setProcessedData] = useState({});
  const [dataForm, setDataForm] = useState({
    tgl_seleksi_vendor: "",
    no_seleksi_vendor: "",
    id_vendor: "",
    nama_vendor: "",
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: "primary",
    text: "",
  });
  const [modalConfig, setModalConfig] = useState({
    show: false,
    type: "create",
  });

  const getInitialData = () => {
    setIsPageLoading(true);

    Axios.all([
      SeleksiVendorApi.getSingle({ id_seleksi_vendor: id }),
      SeleksiVendorApi.getVendorDropdon(),
    ])
      .then(
        Axios.spread((seleksi, vendor) => {
          setDataSeleksiVendor(seleksi.data.data);
          setDataVendor(vendor.data.data);
          setDataListItemSeleksiVendor(seleksi.data.data.detail);
          setDataForm({
            tgl_seleksi_vendor: seleksi.data.data.tgl_seleksi_vendor,
            no_seleksi_vendor: seleksi.data.data.no_seleksi_vendor,
            id_vendor: seleksi.data.data.id_vendor,
            nama_vendor: seleksi.data.data.nama_vendor,
          });
        })
      )
      .catch(() => {
        setIsFetchingFailed(true);
        setAlertConfig({
          show: true,
          variant: "danger",
          text: "Data gagal dimuat!",
        });
      })
      .finally(() => setIsPageLoading(false));
  };

  // const getNoSeleksiVendor = date => {
  //   SeleksiVendorApi.getNomor({tanggal: date})
  //     .then(({data}) => setDataForm({
  //       ...dataForm,
  //       tgl_seleksi_vendor: date,
  //       no_seleksi_vendor: data.data
  //     }))
  //     .catch(() => {
  //       setDataForm({
  //         ...dataForm,
  //         tgl_seleksi_vendor: '',
  //         no_seleksi_vendor: ''
  //       })
  //       setAlertConfig({
  //         show: true,
  //         variant: 'danger',
  //         text: 'Nomor gagal diperoleh!'
  //       })
  //     })
  // }

  useEffect(() => {
    setNavbarTitle("Ubah Seleksi Vendor");
    getInitialData();

    return () => {
      setIsPageLoading(false);
    };
  }, []);

  const PageContent = () => {
    const formInitialValues = {
      id_purchase_request: dataSeleksiVendor.id_purchase_request,
      id_seleksi_vendor: dataSeleksiVendor.id_seleksi_vendor,
      tgl_seleksi_vendor: dataForm.tgl_seleksi_vendor,
      no_seleksi_vendor: dataForm.no_seleksi_vendor,
      id_vendor: dataForm.id_vendor,
      nama_vendor: dataForm.nama_vendor,
    };

    const formValidationSchema = Yup.object().shape({
      tgl_seleksi_vendor: Yup.string().required("Pilih tanggal seleksi vendor"),
      no_seleksi_vendor: Yup.string().required(
        "Pilih tanggal untuk menentukan nomor"
      ),
      id_vendor: Yup.string().required("Pilih vendor"),
    });

    const formSubmitHandler = (values) => {
      const detailData = dataListItemSeleksiVendor.map((val) => {
        return {
          id_item_buaso: val.id_item_buaso,
          qty_order: val.qty_order,
          harga_kesepakatan: parseInt(val.harga_kesepakatan),
        };
      });

      const finalValues = {
        id_purchase_request: values.id_purchase_request,
        id_seleksi_vendor: values.id_seleksi_vendor,
        tgl_seleksi_vendor: values.tgl_seleksi_vendor,
        no_seleksi_vendor: values.no_seleksi_vendor,
        id_vendor: values.id_vendor,
        detail: detailData,
      };

      SeleksiVendorApi.createOrUpdate(finalValues)
        .then((res) => {
          setAlertConfig({
            show: true,
            variant: "primary",
            text: "Data berhasil diubah!",
          });
          getInitialData();
        })
        .catch(() => {
          setAlertConfig({
            show: true,
            variant: "danger",
            text: "Data gagal diubah!",
          });
        });
    };

    const InfoSection = () => {
      const InfoItem = ({ title, value }) => (
        <tr>
          <td>
            <small>{title}</small>
          </td>
          <td>
            <small className="pl-4 pr-2">:</small>
          </td>
          <td>
            <small>{value}</small>
          </td>
        </tr>
      );

      return (
        <>
          <Row>
            <Col>
              <table>
                <tbody>
                  <InfoItem
                    title="Tgl. Purchase Request"
                    value={
                      dataSeleksiVendor.tgl_purchase_request
                        ? DateConvert(
                            new Date(dataSeleksiVendor.tgl_purchase_request)
                          ).detail
                        : "-"
                    }
                  />
                  <InfoItem
                    title="Tgl. Pemakaian"
                    value={
                      dataSeleksiVendor.tgl_pemakaian
                        ? DateConvert(new Date(dataSeleksiVendor.tgl_pemakaian))
                            .detail
                        : "-"
                    }
                  />
                </tbody>
              </table>
            </Col>
            <Col>
              <table>
                <tbody>
                  <InfoItem
                    title="No. Purchase Request"
                    value={
                      dataSeleksiVendor.no_purchase_request
                        ? dataSeleksiVendor.no_purchase_request
                        : "-"
                    }
                  />
                  <InfoItem
                    title="Keperluan"
                    value={
                      dataSeleksiVendor.keperluan
                        ? dataSeleksiVendor.keperluan
                        : "-"
                    }
                  />
                </tbody>
              </table>
            </Col>
          </Row>
          <hr />
        </>
      );
    };

    const FormSection = ({ values, errors, touched }) => {
      return (
        <>
          <Row>
            <Col>
              <DatePicker
                label="Tgl. Seleksi Vendor"
                className="mt-1"
                selected={
                  values.tgl_seleksi_vendor
                    ? new Date(values.tgl_seleksi_vendor)
                    : ""
                }
                onChange={(e) => {
                  const value = e.toISOString().slice(0, 10);
                  setDataForm({
                    ...dataForm,
                    tgl_seleksi_vendor: value,
                  });
                }}
                error={
                  errors.tgl_seleksi_vendor &&
                  touched.tgl_seleksi_vendor &&
                  true
                }
                errorText={errors.tgl_seleksi_vendor}
              />
            </Col>
            <Col>
              <Input
                type="text"
                label="No. Seleksi Vendor"
                placeholder="Pilih tanggal untuk menentukan nomor"
                value={values.no_seleksi_vendor}
                error={
                  errors.no_seleksi_vendor && touched.no_seleksi_vendor && true
                }
                errorText={errors.no_seleksi_vendor}
                readOnly
              />
            </Col>
          </Row>
          <SelectSearch
            label="Vendor"
            placeholder="Pilih vendor"
            defaultValue={
              values.id_vendor
                ? {
                    value: values.id_vendor,
                    label: values.nama_vendor,
                  }
                : ""
            }
            option={dataVendor.map((val) => {
              return {
                value: val.id_vendor,
                label: val.nama_vendor,
              };
            })}
            onChange={(val) => {
              setDataForm({
                ...dataForm,
                id_vendor: val.value,
                nama_vendor: val.label,
              });
            }}
            error={errors.id_vendor && touched.id_vendor && true}
            errorText={
              errors.id_vendor && touched.id_vendor && errors.id_vendor
            }
          />
        </>
      );
    };

    const ListItemPurchaseRequestSection = () => {
      const cantProcess = dataListItemSeleksiVendor.length > 0 ? true : false;
      const TableListItemPurchaseRequest = () => (
        <Table>
          <THead>
            <Tr>
              <ThFixed>No.</ThFixed>
              <ThFixed>Kode Item</ThFixed>
              <Th>Nama Item</Th>
              <Th>Satuan Beli</Th>
              <Th>Qty PR</Th>
              <Th>Qty Order</Th>
              <Th>Harga Perkiraan</Th>
              <ThFixed>Aksi</ThFixed>
            </Tr>
          </THead>
          <TBody>
            {dataSeleksiVendor.pr_detail.map((val, index) => (
              <Tr key={index}>
                <TdFixed>{index + 1}</TdFixed>
                <TdFixed>{val.kode_item}</TdFixed>
                <Td>
                  <div style={{ width: "200px" }}>{val.nama_item}</div>
                </Td>
                <Td>{val.satuan_beli}</Td>
                <Td textRight>{val.qty_pr}</Td>
                <Td textRight>{val.qty_ordered}</Td>
                <Td textRight>
                  {
                    RupiahConvert(
                      parseFloat(val.harga_perkiraan_sendiri).toString()
                    ).getWithComa
                  }
                </Td>
                <Td>
                  <ActionButton
                    size="sm"
                    className="text-nowrap"
                    text={<IoAddOutline />}
                    disable={cantProcess}
                    onClick={() => {
                      setProcessedData(val);
                      setModalConfig({
                        show: true,
                        type: "create",
                      });
                    }}
                  />
                </Td>
              </Tr>
            ))}
          </TBody>
        </Table>
      );

      return (
        <>
          <div className="py-2 pl-1">
            <b>List Item Purchase Request</b>
          </div>
          {dataSeleksiVendor.pr_detail ? (
            dataSeleksiVendor.pr_detail.length > 0 ? (
              <TableListItemPurchaseRequest />
            ) : (
              <DataStatus text="Tidak ada data" />
            )
          ) : (
            <DataStatus text="Tidak ada data" />
          )}
        </>
      );
    };

    const ListItemSeleksiVendorSection = () => {
      const TableListItemSeleksiVendor = () => {
        let total = 0;

        return (
          <Table>
            <THead>
              <Tr>
                <ThFixed>No.</ThFixed>
                <ThFixed>Kode Item</ThFixed>
                <Th>Nama Item</Th>
                <Th>Satuan Beli</Th>
                <Th>Qty Order</Th>
                <Th>Harga Kesepakatan</Th>
                <Th>Jumlah</Th>
                <ThFixed>Aksi</ThFixed>
              </Tr>
            </THead>
            <TBody>
              {dataListItemSeleksiVendor.map((val, index) => {
                total = total + val.harga_kesepakatan * val.qty_order;

                return (
                  <Tr key={index}>
                    <TdFixed>{index + 1}</TdFixed>
                    <TdFixed>{val.kode_item}</TdFixed>
                    <Td>
                      <div style={{ width: "200px" }}>{val.nama_item}</div>
                    </Td>
                    <Td>{val.satuan_beli}</Td>
                    <Td textRight>{val.qty_order}</Td>
                    <Td textRight>
                      {
                        RupiahConvert(
                          parseFloat(val.harga_kesepakatan).toString()
                        ).getWithComa
                      }
                    </Td>
                    <Td textRight>
                      {
                        RupiahConvert(
                          (
                            val.qty_order * parseFloat(val.harga_kesepakatan)
                          ).toString()
                        ).getWithComa
                      }
                    </Td>
                    <Td className="d-flex">
                      {val.editable && (
                        <UpdateButton
                          onClick={() => {
                            setProcessedData({
                              index,
                              ...val,
                            });
                            setModalConfig({
                              show: true,
                              type: "update",
                            });
                          }}
                        />
                      )}
                      {val.deletable && (
                        <DeleteButton
                          onClick={() => {
                            setProcessedData({
                              index,
                              ...val,
                            });
                            setModalConfig({
                              show: true,
                              type: "delete",
                            });
                          }}
                        />
                      )}
                    </Td>
                  </Tr>
                );
              })}
              <Tr>
                <Td colSpan={7} textRight>
                  <b>Total</b>
                </Td>
                <Td textRight>
                  <b>{RupiahConvert(total.toString()).getWithComa}</b>
                </Td>
              </Tr>
            </TBody>
          </Table>
        );
      };

      return (
        <>
          <div className="py-2 pl-1">
            <b>List Item Seleksi Vendor</b>
          </div>
          {dataListItemSeleksiVendor ? (
            dataListItemSeleksiVendor.length > 0 ? (
              <TableListItemSeleksiVendor />
            ) : (
              <DataStatus text="Tidak ada data" />
            )
          ) : (
            <DataStatus text="Tidak ada data" />
          )}
          <hr />
        </>
      );
    };

    const ButtonSection = ({ isSubmitting }) => (
      <div className="d-flex justify-content-end my-3">
        <ActionButton
          type="submit"
          variant="success"
          text="Ubah Data Seleksi Vendor"
          loading={isSubmitting}
        />
      </div>
    );

    return (
      <Formik
        enableReinitialize
        initialValues={formInitialValues}
        validationSchema={formValidationSchema}
        onSubmit={formSubmitHandler}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          setFieldValue,
          handleChange,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <InfoSection />
            <FormSection values={values} errors={errors} touched={touched} />
            <ListItemPurchaseRequestSection />
            <ListItemSeleksiVendorSection />
            <ButtonSection isSubmitting={isSubmitting} />
          </form>
        )}
      </Formik>
    );
  };

  const PageModal = () => {
    const ModalTitle = () =>
      modalConfig.type.toLowerCase() === "update" ? (
        <span className="text-success">Ubah Item Seleksi Vendor</span>
      ) : modalConfig.type.toLowerCase() === "delete" ? (
        <span className="text-danger">Hapus Item Seleksi Vendor</span>
      ) : (
        <span className="text-primary">Tambah Item Seleksi Vendor</span>
      );

    const ModalForm = () => {
      const formInitialValues = {
        kode_item: processedData.kode_item,
        id_item_buaso: processedData.id_item_buaso,
        nama_item: processedData.nama_item,
        satuan_beli: processedData.satuan_beli,
        qty_pr: processedData.qty_pr,
        qty_order:
          modalConfig.type.toLowerCase() === "update"
            ? processedData.qty_order
            : processedData.qty_ordered,
        harga_perkiraan_sendiri: processedData.harga_perkiraan_sendiri,
        harga_kesepakatan: processedData.harga_kesepakatan
          ? processedData.harga_kesepakatan
          : processedData.harga_perkiraan_sendiri,
        editable: true,
        deletable: true,
      };

      const formValidationSchema = Yup.object().shape({
        qty_order: Yup.string().required("Masukan qty"),
        harga_kesepakatan: Yup.string().required("Masukan harga kesepakatan"),
      });

      const formSubmitHandler = (value) => {
        const createData = () => {
          setDataListItemSeleksiVendor([...dataListItemSeleksiVendor, value]);
          setModalConfig({
            ...modalConfig,
            show: false,
          });
          setAlertConfig({
            show: true,
            variant: "primary",
            text: "Data berhasil ditambah!",
          });
        };

        const updateData = () => {
          const filteredData = [];

          dataListItemSeleksiVendor.map((val, index) =>
            index === processedData.index
              ? filteredData.push(value)
              : filteredData.push(val)
          );

          setDataListItemSeleksiVendor(filteredData);
          setModalConfig({
            ...modalConfig,
            show: false,
          });
          setAlertConfig({
            show: true,
            variant: "primary",
            text: "Data berhasil diubah!",
          });
        };

        setTimeout(() => {
          modalConfig.type === "update" ? updateData() : createData();
        }, 100);
      };

      return (
        <Formik
          enableReinitialize
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Body>
                <Input
                  label="Item Purchase Request"
                  type="text"
                  value={values.nama_item}
                  readOnly
                />
                <Row>
                  <Col>
                    <Input
                      label="Qty. Purchase Request"
                      type="text"
                      value={values.qty_pr ? values.qty_pr : "-"}
                      readOnly
                    />
                  </Col>
                  <Col>
                    <Input
                      label="Satuan Beli"
                      type="text"
                      value={values.satuan_beli}
                      readOnly
                    />
                  </Col>
                </Row>
                <Input
                  label="Harga Perkiraan Sendiri (HPS)"
                  type="text"
                  value={
                    values.harga_perkiraan_sendiri
                      ? RupiahConvert(
                          parseFloat(values.harga_perkiraan_sendiri).toString()
                        ).getWithComa
                      : "-"
                  }
                  readOnly
                />
                <Row>
                  <Col>
                    <Input
                      label="Qty. Order"
                      type="text"
                      name="qty_order"
                      placeholder="Masukan qty. order"
                      value={values.qty_order}
                      onChange={handleChange}
                      error={errors.qty_order && touched.qty_order && true}
                      errorText={errors.qty_order}
                    />
                  </Col>
                  <Col>
                    <InputCurrency
                      label="Harga Kesepakatan"
                      placeholder="Masukan harga kesepakatan"
                      value={parseFloat(values.harga_kesepakatan)}
                      onChange={(e) => {
                        setFieldValue("harga_kesepakatan", e);
                      }}
                      error={
                        errors.harga_kesepakatan &&
                        touched.harga_kesepakatan &&
                        true
                      }
                      errorText={errors.harga_kesepakatan}
                    />
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                {modalConfig.type.toLowerCase() === "update" ? (
                  <ActionButton
                    type="submit"
                    variant="success"
                    text="Ubah Data"
                    loading={isSubmitting}
                  />
                ) : (
                  <ActionButton
                    type="submit"
                    variant="primary"
                    text="Tambah Data"
                    loading={isSubmitting}
                  />
                )}
              </Modal.Footer>
            </form>
          )}
        </Formik>
      );
    };

    const ModalDelete = () => {
      const [isDeleting, setIsDeleting] = useState(false);

      const deleteDataHandler = () => {
        setIsDeleting(true);

        const filteredData = dataListItemSeleksiVendor.filter(
          (value, index) => processedData.index !== index
        );

        setTimeout(() => {
          setDataListItemSeleksiVendor(filteredData);
          setIsDeleting(false);
          setModalConfig({
            ...modalConfig,
            show: false,
          });
          setAlertConfig({
            show: true,
            variant: "primary",
            text: "Data berhasil dihapus!",
          });
        }, 100);
      };

      useEffect(() => {
        return () => {
          setIsDeleting(false);
        };
      }, []);

      const ModalDeleteText = () => (
        <>
          <h5>
            <span>Hapus data dengan nama item: </span>
            <br />
            <b>{processedData.nama_item}</b>
          </h5>
          <small className="text-danger">
            Data yang dihapus tidak dapat dikembalikan!
          </small>
        </>
      );

      const ModalDeleteButton = () => (
        <div className="d-flex justify-content-center mt-3">
          <ActionButton
            variant="outline-secondary"
            className="m-1"
            text="Batal"
            onClick={() =>
              setModalConfig({
                ...modalConfig,
                show: false,
              })
            }
          />
          <ActionButton
            variant="danger"
            className="m-1"
            text="Hapus Data"
            loading={isDeleting}
            onClick={deleteDataHandler}
          />
        </div>
      );

      return (
        <>
          <Modal.Body className="text-center">
            <ModalDeleteText />
            <ModalDeleteButton />
          </Modal.Body>
        </>
      );
    };

    return (
      <Modal
        show={modalConfig.show}
        onHide={() =>
          setModalConfig({
            ...modalConfig,
            show: false,
          })
        }
      >
        <Modal.Header closeButton>
          <ModalTitle />
        </Modal.Header>
        {modalConfig.type.toLowerCase() === "delete" ? (
          <ModalDelete />
        ) : (
          <ModalForm />
        )}
      </Modal>
    );
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between align-items-center">
        <b>Ubah Data Seleksi Vendor</b>
        <BackButton onClick={() => history.push("/transaksi/seleksi-vendor")} />
      </Card.Header>
      <Card.Body>
        <Alert
          showCloseButton
          show={alertConfig.show}
          variant={alertConfig.variant}
          text={alertConfig.text}
          onClose={() =>
            setAlertConfig({
              ...alertConfig,
              show: false,
            })
          }
        />
        {isPageLoading ? (
          <DataStatus loading={true} text="Memuat data . . ." />
        ) : isFetchingFailed ? (
          <DataStatus text="Data gagal dimuat, tidak dapat menambah data!" />
        ) : (
          <PageContent />
        )}
      </Card.Body>
      <PageModal />
    </Card>
  );
};

export default UbahSeleksiVendor;
